import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faPlus, faCheck } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import { adminFetch } from '../../../utils/api';
import './TiposClienteData.css';

export default function TiposClienteData() {
    const [tipos, setTipos] = useState([]);
    const [editando, setEditando] = useState(null);
    const [nuevo, setNuevo] = useState({ nombre: '', descripcion: '' });
    const [mostrarForm, setMostrarForm] = useState(false);

    useEffect(() => { cargarTipos(); }, []);

    const cargarTipos = () => {
        adminFetch(`${baseURL}/api/admin/tipos-cliente`, { method: 'GET' })
            .then(r => r.json())
            .then(data => setTipos(data.tipos || []))
            .catch(() => {});
    };

    const crearTipo = () => {
        if (!nuevo.nombre.trim()) { toast.error('El nombre es requerido'); return; }
        adminFetch(`${baseURL}/api/admin/tipos-cliente`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(nuevo),
        })
            .then(r => r.json())
            .then(data => {
                if (data.idTipoCliente) {
                    toast.success('Tipo creado');
                    setNuevo({ nombre: '', descripcion: '' });
                    setMostrarForm(false);
                    cargarTipos();
                } else { toast.error(data.error || 'Error al crear'); }
            })
            .catch(() => toast.error('Error de conexión'));
    };

    const guardarEdicion = () => {
        adminFetch(`${baseURL}/api/admin/tipos-cliente/${editando.idTipoCliente}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nombre: editando.nombre, descripcion: editando.descripcion }),
        })
            .then(r => r.json())
            .then(data => {
                if (data.mensaje) { toast.success('Actualizado'); setEditando(null); cargarTipos(); }
                else { toast.error(data.error || 'Error'); }
            })
            .catch(() => toast.error('Error de conexión'));
    };

    const eliminarTipo = (id, nombre) => {
        Swal.fire({
            title: `¿Eliminar "${nombre}"?`,
            text: 'Si tiene clientes asignados, se desactivará en lugar de eliminarse.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e74c3c',
            cancelButtonColor: '#aaa',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(result => {
            if (!result.isConfirmed) return;
            adminFetch(`${baseURL}/api/admin/tipos-cliente/${id}`, { method: 'DELETE' })
                .then(r => r.json())
                .then(data => { toast.success(data.mensaje || 'Eliminado'); cargarTipos(); })
                .catch(() => toast.error('Error de conexión'));
        });
    };

    const abrirForm = () => {
        setMostrarForm(true);
        setEditando(null);
    };

    return (
        <div className="tipos-page">
            <ToastContainer />

            <div className="tipos-header">
                <h2>Tipos de Cliente</h2>
                <button className="tipos-btn-nuevo" onClick={abrirForm}>
                    <FontAwesomeIcon icon={faPlus} />
                    Nuevo tipo
                </button>
            </div>

            {mostrarForm && (
                <div className="tipos-form-panel">
                    <h3>Nuevo tipo de cliente</h3>
                    <div className="tipos-form-row">
                        <input
                            type="text"
                            placeholder="Nombre *"
                            value={nuevo.nombre}
                            onChange={e => setNuevo(v => ({ ...v, nombre: e.target.value }))}
                            maxLength={100}
                            autoFocus
                            onKeyDown={e => e.key === 'Enter' && crearTipo()}
                        />
                        <input
                            type="text"
                            placeholder="Descripción (opcional)"
                            value={nuevo.descripcion}
                            onChange={e => setNuevo(v => ({ ...v, descripcion: e.target.value }))}
                            maxLength={255}
                        />
                    </div>
                    <div className="tipos-form-actions">
                        <button className="tipos-btn-guardar" onClick={crearTipo}>
                            <FontAwesomeIcon icon={faCheck} style={{ marginRight: 6 }} />
                            Guardar
                        </button>
                        <button className="tipos-btn-cancelar" onClick={() => setMostrarForm(false)}>
                            Cancelar
                        </button>
                    </div>
                </div>
            )}

            {tipos.length === 0 ? (
                <p className="tipos-empty">Sin tipos de cliente registrados</p>
            ) : (
                <div className="tipos-grid">
                    {tipos.map(t => {
                        const isEditing = editando?.idTipoCliente === t.idTipoCliente;
                        return (
                            <div key={t.idTipoCliente} className={`tipo-card${isEditing ? ' tipo-card--editing' : ''}`}>
                                <div className="tipo-card-accent" />

                                <div className="tipo-card-body">
                                    {isEditing ? (
                                        <>
                                            <div className="tipo-card-edit-group">
                                                <span className="tipo-card-edit-label">Nombre *</span>
                                                <input
                                                    value={editando.nombre}
                                                    onChange={e => setEditando(v => ({ ...v, nombre: e.target.value }))}
                                                    maxLength={100}
                                                    autoFocus
                                                    onKeyDown={e => e.key === 'Enter' && guardarEdicion()}
                                                />
                                            </div>
                                            <div className="tipo-card-edit-group">
                                                <span className="tipo-card-edit-label">Descripción</span>
                                                <input
                                                    value={editando.descripcion || ''}
                                                    onChange={e => setEditando(v => ({ ...v, descripcion: e.target.value }))}
                                                    maxLength={255}
                                                    placeholder="Sin descripción"
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <p className="tipo-card-name">{t.nombre}</p>
                                            <p className="tipo-card-desc">{t.descripcion || 'Sin descripción'}</p>
                                        </>
                                    )}
                                </div>

                                <div className="tipo-card-footer">
                                    {isEditing ? (
                                        <div className="tipo-card-actions">
                                            <button className="tipo-btn-save" onClick={guardarEdicion}>
                                                Guardar
                                            </button>
                                            <button className="tipo-btn-cancel-edit" onClick={() => setEditando(null)}>
                                                Cancelar
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="tipo-card-actions">
                                            <button
                                                className="tipo-btn-icon tipo-btn-edit"
                                                title="Editar"
                                                onClick={() => { setEditando({ ...t }); setMostrarForm(false); }}
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                            <button
                                                className="tipo-btn-icon tipo-btn-delete"
                                                title="Eliminar"
                                                onClick={() => eliminarTipo(t.idTipoCliente, t.nombre)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
